// Algerian wilayas (58 official + labels FR/AR)
export const WILAYAS = [
  { n: 1, fr: "Adrar", ar: "أدرار" },
  { n: 2, fr: "Chlef", ar: "الشلف" },
  { n: 3, fr: "Laghouat", ar: "الأغواط" },
  { n: 4, fr: "Oum El Bouaghi", ar: "أم البواقي" },
  { n: 5, fr: "Batna", ar: "باتنة" },
  { n: 6, fr: "Béjaïa", ar: "بجاية" },
  { n: 7, fr: "Biskra", ar: "بسكرة" },
  { n: 8, fr: "Béchar", ar: "بشار" },
  { n: 9, fr: "Blida", ar: "البليدة" },
  { n: 10, fr: "Bouira", ar: "البويرة" },
  { n: 11, fr: "Tamanrasset", ar: "تمنراست" },
  { n: 12, fr: "Tébessa", ar: "تبسة" },
  { n: 13, fr: "Tlemcen", ar: "تلمسان" },
  { n: 14, fr: "Tiaret", ar: "تيارت" },
  { n: 15, fr: "Tizi Ouzou", ar: "تيزي وزو" },
  { n: 16, fr: "Alger", ar: "الجزائر" },
  { n: 17, fr: "Djelfa", ar: "الجلفة" },
  { n: 18, fr: "Jijel", ar: "جيجل" },
  { n: 19, fr: "Sétif", ar: "سطيف" },
  { n: 20, fr: "Saïda", ar: "سعيدة" },
  { n: 21, fr: "Skikda", ar: "سكيكدة" },
  { n: 22, fr: "Sidi Bel Abbès", ar: "سيدي بلعباس" },
  { n: 23, fr: "Annaba", ar: "عنابة" },
  { n: 24, fr: "Guelma", ar: "قالمة" },
  { n: 25, fr: "Constantine", ar: "قسنطينة" },
  { n: 26, fr: "Médéa", ar: "المدية" },
  { n: 27, fr: "Mostaganem", ar: "مستغانم" },
  { n: 28, fr: "M'Sila", ar: "المسيلة" },
  { n: 29, fr: "Mascara", ar: "معسكر" },
  { n: 30, fr: "Ouargla", ar: "ورقلة" },
  { n: 31, fr: "Oran", ar: "وهران" },
  { n: 32, fr: "El Bayadh", ar: "البيض" },
  { n: 33, fr: "Illizi", ar: "إليزي" },
  { n: 34, fr: "Bordj Bou Arréridj", ar: "برج بوعريريج" },
  { n: 35, fr: "Boumerdès", ar: "بومرداس" },
  { n: 36, fr: "El Tarf", ar: "الطارف" },
  { n: 37, fr: "Tindouf", ar: "تندوف" },
  { n: 38, fr: "Tissemsilt", ar: "تيسمسيلت" },
  { n: 39, fr: "El Oued", ar: "الوادي" },
  { n: 40, fr: "Khenchela", ar: "خنشلة" },
  { n: 41, fr: "Souk Ahras", ar: "سوق أهراس" },
  { n: 42, fr: "Tipaza", ar: "تيبازة" },
  { n: 43, fr: "Mila", ar: "ميلة" },
  { n: 44, fr: "Aïn Defla", ar: "عين الدفلى" },
  { n: 45, fr: "Naâma", ar: "النعامة" },
  { n: 46, fr: "Aïn Témouchent", ar: "عين تموشنت" },
  { n: 47, fr: "Ghardaïa", ar: "غرداية" },
  { n: 48, fr: "Relizane", ar: "غليزان" },
  { n: 49, fr: "Timimoun", ar: "تيميمون" },
  { n: 50, fr: "Bordj Badji Mokhtar", ar: "برج باجي مختار" },
  { n: 51, fr: "Ouled Djellal", ar: "أولاد جلال" },
  { n: 52, fr: "Béni Abbès", ar: "بني عباس" },
  { n: 53, fr: "In Salah", ar: "عين صالح" },
  { n: 54, fr: "In Guezzam", ar: "عين قزام" },
  { n: 55, fr: "Touggourt", ar: "تقرت" },
  { n: 56, fr: "Djanet", ar: "جانت" },
  { n: 57, fr: "El M'Ghair", ar: "المغير" },
  { n: 58, fr: "El Meniaa", ar: "المنيعة" },
];
